import { Component,ElementRef,Inject } from '@angular/core';
import { DOCUMENT } from  '@angular/common';
import { Router,NavigationCancel,NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators'
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'my-new-app';
  public apiLocation: string;
  public ntPrinter: string;
  public ntAddress: string;
    constructor(el:ElementRef,@Inject(DOCUMENT) private document: Document, private router: Router,public appservice:AppService) {
    // const appRoot = this.document.querySelector('app-root');
    // this.apiLocation = appRoot?.getAttribute('API_Location') || '';
    // this.ntPrinter = appRoot?.getAttribute('NT_Printer') || '';
    // this.ntAddress = appRoot?.getAttribute('NT_Address') || '';
     this.appservice.ApiUrl = el.nativeElement.getAttribute('API_Location');    
     var NT_P=el.nativeElement.getAttribute('NT_Printer');
     var NT_A=el.nativeElement.getAttribute('NT_Address');
     //this.appservice.NT_Printer=NT_P;
     //this.appservice.NT_Address=NT_A;
  }
}
